<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">Save Report Definition</h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-button
              type="is-primary import-button"
              v-on:click="submit('send_for_approval')"
              >Send for Approval</b-button
            >
            <b-button
              type="is-success import-button"
              v-on:click="submit('save_as_draft')"
              >Save as Draft</b-button
            >
            <b-button type="is-normal import-button" v-on:click="cancel"
              >Cancel</b-button
            >
          </div>
        </div>
      </section>
    </div>
  </b-modal>
</template>
<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
// @group Dashboard
export default {
  name: "WorkflowDialog",
  mixins: [UtilityMixin, scopeMixin],
  props: {
    isActive: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isModalActive: false,
      loading: "",
      selectedRule: null
    };
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    submit(value) {
      this.$emit("submit", value);
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
